import horizontalBarChart from '@/assets/images/horizontal-bar-chart.svg';
import donutChart from '@/assets/images/donut-chart.svg';
import table from '@/assets/images/table.svg';
import map from '@/assets/images/map.svg';
import horizontalStatus from '@/assets/images/horizontal-status.svg';
import verticalStatus from '@/assets/images/vertical-status.svg';

const horizontalBarChartPreview = { previewComponent: horizontalBarChart, height: '124px', width: '181px' };
const donutChartPreview = { previewComponent: donutChart, height: '124px', width: '181px' };
const horizontalStatusPreview = { previewComponent: horizontalStatus, height: '124px', width: '181px' };
const verticalStatusPreview = { previewComponent: verticalStatus, height: '124px', width: '181px' };
const tablePreview = { previewComponent: table, height: '109px', width: '305px' };
const mapPreview = { previewComponent: map, height: '109px', width: '305px' };

const displayWidgetPreview = (previewComponent: string) => {
  switch (previewComponent) {
    case 'donutChartPreview':
      return donutChartPreview;
    case 'mapPreview':
      return mapPreview;
    case 'horizontalStatusPreview':
      return horizontalStatusPreview;
    case 'verticalStatusPreview':
      return verticalStatusPreview;
    case 'tablePreview':
      return tablePreview;
    default:
      return horizontalBarChartPreview;
  }
};

export {
    displayWidgetPreview,
};
